module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid__tile--grid"
  }, _vm._l((_vm.data), function(dataItem) {
    return _c('div', {
      staticClass: "grid__tile"
    }, [_c('span', {
      staticClass: "grid__data"
    }, [_vm._v(_vm._s(dataItem.data))]), _vm._v(" "), _c('span', {
      staticClass: "grid__label"
    }, [_vm._v(_vm._s(dataItem.label))])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e2d70a0c!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/layout/grid/TileGrid.vue
// module id = 765
// module chunks = 1